import axios from './axios'

export const sendSupportEmail = params =>
  axios.postJson('/jobs/send_mail', params)
